import { getAuth } from 'firebase/auth';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setStoreSelected } from 'v3/data/store/stores/actions';
import { RoutesEnum } from 'v3/routes/enum';
import api from 'v3/services/config';
import onlineApi, { onlineLomApi } from 'v3/services/online/config';

export default function useAuthentication() {
  const navigate = useNavigate();
  const [isLoggedin, setIsLoggedin] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(true);
  const auth = getAuth();

  const getCurrentUser = useCallback(() => {
    try {
      auth.onAuthStateChanged(async function (user) {
        if (user) {
          setIsLoggedin(true);
          setAuthorization(await user.getIdToken(true));
          setStoreSelected({
            storeUserId: user.uid,
            name: String(user.email),
          });
        }
        setFetching(false);
      });
    } catch (error) {
      navigate(RoutesEnum.HomeAuth);
    }
  }, [navigate, auth]);

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  function setAuthorization(accessToken: string | undefined) {
    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    onlineApi.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    onlineLomApi.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  }

  return { isLoggedin, fetching };
}
